import { styled } from "styled-components"
import { AlignBox, EmtpyBox, PaddingBox, Textfleid } from "../atom"
import { Navigate, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { isNickname } from "../utill/isNickname"
import { postAPI } from "../apis/useAPI"
import { trackEvent } from "../apis/amplitude"

const Login = () => {

    const nav = useNavigate()

    const [id, setId] = useState('')
    const [pw, setPw] = useState('')

    useEffect(() => trackEvent('입장'), [])

    function generateRandomId() {
        const minLength = 1;
        const maxLength = 16;
      
        const length = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;
        
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let id = '';
      
        while (id.length < length) {
          const randomIndex = Math.floor(Math.random() * characters.length);
          const randomCharacter = characters.charAt(randomIndex);
          id += randomCharacter;
        }
      
        return id;
      }
      

    const ClickHandler = async () => {

        const id = generateRandomId();

        nav('/question', {state: {id: id}})
        trackEvent('로그인', {id: id})

        // console.log("눌럼짐");
        
        // if(!isNickname(id)) return alert('아이디는 2~10자의 한글, 영문, 숫자만 사용 가능합니다.')
        // if(id === '' || pw === '') return alert('아이디와 비밀번호를 입력해주세요')

        // const res = await postAPI('login', {id: id, pw: pw})

        // console.log(res);

        // if (res === 1) {
        //     nav('/question', {state: {id: id}})
        //     trackEvent('로그인', {id: id})
        // } else {
        //     alert('중복된 아이디거나, 비밀번호가 틀렸습니다.')
        //     trackEvent('로그인 오류', {id: id})
        // }
    }

    return (
        <LoginContainer>
            <h2>당신을 위한 <br /> <Blue>소울</Blue>메이트 찾기 서비스</h2>
            <EmtpyBox height={6} />
            <AlignBox align="right"><b>DEMO</b></AlignBox>
            <EmtpyBox height={10} />
            <AlignBox align="center">
                {/* <div style={{width: "38px", height: "4px", backgroundColor: "black"}}/>
                <EmtpyBox height={5} />
                
            </AlignBox>
            <AlignBox align="center">
                <EmtpyBox height={6} />
                    <b style={{textAlign: "left", width: '262px'}}>아이디</b>
                    <EmtpyBox height={2} />
                    <Textfleid
                        value={id}
                        onChange={(e) => {setId(e.target.value)}}
                    />
                <EmtpyBox height={6} />
                    <b style={{textAlign: "left", width: '262px'}}>비밀번호</b>
                    <EmtpyBox height={2} />
                    <Textfleid 
                        type="password"
                        value={pw}
                        onChange={(e) => {setPw(e.target.value)}}
                    />
            <EmtpyBox height={10} />
                <p>데모 때 계속 쓸 수 있는 임시 계정입니다!</p>
                <p>자동으로 회원가입 혹은 로그인 됩니다!</p> */}
            <h3 style={{position: 'absolute', bottom: '130px'}}>👇 바로 입장하기 👇</h3>
            <Btn onClick={ClickHandler}>로그인하기</Btn>
            </AlignBox>
        </LoginContainer>
    )
}

const LoginContainer = styled.div`
    padding: 77px 50px 0 50px;
`

const Blue = styled.span`
    color: #4F8FFB;
`

const Btn = styled.div`
    position: absolute;
    bottom: 50px;
    
    display: flex;
    justify-content: center;
    align-items: center;
    width: 268px;
    height: 55px;
    background-color: #000;
    border-radius: 32px;
    color: #fff;
`

export default Login